import React from 'react';

import { isFullRemoteOnlyByQueryParam } from '@/domain/search/helpers';
import { LocationSuggestion } from '@/hooks';

import { useSearchQuery } from '../../../contexts';
import { SearchBoxComponent } from '../search-box-component';

type Props = {
  setTrackAction: (action: string) => void;
};

export const InternalSearchBox: React.FC<Props> = ({ setTrackAction }) => {
  const {
    searchBox: [{ keywordsInput, locationInput, radiusInput }, setSearchBoxInputValues],
    queryParams: [{ remoteOption }, setQueryParams],
  } = useSearchQuery();

  const onChangeKeywords = (value: string): void => {
    setSearchBoxInputValues({ keywordsInput: value });
  };

  const onSelectKeywords = (value: string): void => setSearchBoxInputValues({ keywordsInput: value });

  const onChangeLocation = (value: string): void => {
    setSearchBoxInputValues({ locationInput: value });
    setSearchBoxInputValues({ cityIdInput: '' });
  };

  const onSelectLocation = (item: LocationSuggestion): void => {
    setSearchBoxInputValues({ locationInput: item.location });
    setSearchBoxInputValues({ cityIdInput: item.cityId });
  };

  const onClickRadiusOption = (radiusOption: number): void => {
    setSearchBoxInputValues({ radiusInput: radiusOption });
  };

  const onSubmit = (): void => {
    setQueryParams();
    setTrackAction('jobs_search_button');
  };

  return (
    <SearchBoxComponent
      keywordsInput={keywordsInput ?? ''}
      locationInput={locationInput ?? ''}
      radiusInput={radiusInput ?? 0}
      isLocationDisabled={isFullRemoteOnlyByQueryParam(remoteOption)}
      onChangeKeywords={onChangeKeywords}
      onSelectKeywords={onSelectKeywords}
      onChangeLocation={onChangeLocation}
      onSelectLocation={onSelectLocation}
      onSelectRadius={onClickRadiusOption}
      onSubmit={onSubmit}
    />
  );
};
